module.exports = "<button (click)=\"shout($event);\" mat-raised-button>WHAT</button>\r\n<mat-list dense>\r\n  <mat-list-item *ngFor=\"let country of countryList; let i = index\">\r\n    <span class=\"list-item\">\r\n      {{country}}\r\n    </span>\r\n  </mat-list-item>\r\n</mat-list>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/Workspace/hyblab-migration/src/app/country-list/country-list.component.html
// module id = ../../../../../src/app/country-list/country-list.component.html
// module chunks = main